import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-align-left",
  templateUrl: "./med-icon-align-left.component.html",
})
export class MedIconAlignLeftComponent extends SvgMixinComponent {}
